import { render, staticRenderFns } from "./VerticalNavMenuHeader.vue?vue&type=template&id=458a356b&scoped=true&"
import script from "./VerticalNavMenuHeader.vue?vue&type=script&lang=js&"
export * from "./VerticalNavMenuHeader.vue?vue&type=script&lang=js&"
import style0 from "./VerticalNavMenuHeader.vue?vue&type=style&index=0&id=458a356b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458a356b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSlideXTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VIcon,VImg,VSlideXTransition})
